import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
const START_SECONDS = 17 * 60 + 34;
interface CountdownProps {
  tone?: 'dark' | 'light';
}
export function Countdown({
  tone = 'dark'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(START_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? START_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const isDark = tone === 'dark';
  const boxClass = isDark ? 'bg-navy-900 text-cream-50' : 'bg-white text-navy-900 ring-1 ring-navy-900/10';
  return <div className="flex flex-col items-center gap-2" data-id="element-109" data-mp="10a8xagn94e25">
      <p className={['flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.16em] sm:text-xs', isDark ? 'text-navy-700' : 'text-gold-300'].join(' ')} data-id="element-110" data-mp="15add04gc54rb">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="t1adf0u5xw6e" />
        This special offer ends in:
      </p>
      <div className="flex items-center gap-1.5" role="timer" aria-live="off" aria-label={`Offer ends in ${pad(hours)} hours ${pad(minutes)} minutes ${pad(seconds)} seconds`} data-id="element-112" data-mp="17qgeyvgh3yhg">
        {[{
        v: hours,
        l: 'HRS'
      }, {
        v: minutes,
        l: 'MIN'
      }, {
        v: seconds,
        l: 'SEC'
      }].map((unit, i) => <React.Fragment key={unit.l} data-id="element-113" data-mp="o38yms3rsj0q" data-mpi={i}>
            {i > 0 && <span className={`pb-4 text-xl font-bold ${isDark ? 'text-navy-700' : 'text-gold-400'}`} aria-hidden="true" data-id="element-114" data-mp="o0nwe1zk812g">
                :
              </span>}
            <div className={`flex w-[64px] flex-col items-center rounded-xl px-2 py-2 sm:w-[76px] ${boxClass}`} data-id="element-115" data-mp="1vh3o1k24ku5l">
              <span className="font-display text-2xl font-bold tabular-nums sm:text-3xl" data-id="element-116" data-mp="s54yz8nwvrof">
                {pad(unit.v)}
              </span>
              <span className="text-[9px] font-bold uppercase tracking-[0.14em] opacity-60" data-id="element-117" data-mp="123ui14rjni69">
                {unit.l}
              </span>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}